module.exports = __webpack_public_path__ + "img/home-main.b559ce11.jpg";